module.exports = __webpack_public_path__ + "img/activeuparrow.57a21310.svg";